import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-inactive-billing-programs',
  templateUrl: './tryout-inactive-billing-programs.component.html',
  styleUrls: ['./tryout-inactive-billing-programs.component.css']
})
export class TryoutInactiveBillingProgramsComponent implements OnInit {

  @Input() NoOfInactiveBillingPrograms: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-inactive-billing-programs/tryout-inactive-billing-programs.component.ts